import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=ba07893c&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=ba07893c&lang=sass&scoped=true&"
import style1 from "./Home.vue?vue&type=style&index=1&id=ba07893c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba07893c",
  null
  
)

export default component.exports